import {LAYERINFORMATION} from './LayerInformationTypes'

export const changeLayerInformation = layerInformation => {
    return {
        type: LAYERINFORMATION,
        load: layerInformation
    }
}
export const selectNewLayerInformation = (layerInformation) => {

    return (dispatch) => {
        dispatch(changeLayerInformation(layerInformation))
    }

}